import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdOutlineAccountBalance, MdWarning, MdSchedule } from 'react-icons/md';
import { usePppApi } from '../services/pppApi';

function fmt(n) {
  return n != null ? String(n) : '—';
}

function PppStatCard({ icon, label, value, sub, gradient, onClick, loading }) {
  return (
    <div
      className={`bg-white dark:bg-secondary-dark-bg rounded-card shadow-card p-5 flex flex-col gap-4 animate-[fade-in_0.3s_ease-out] ${onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-1">
            {label}
          </p>
          <p className="text-3xl font-extrabold text-gray-800 dark:text-dark-text">
            {loading ? '…' : fmt(value)}
          </p>
          {sub && (
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
              {loading ? '' : sub}
            </p>
          )}
        </div>
        <div
          className="w-12 h-12 rounded-xl flex items-center justify-center text-white text-2xl shadow-btn flex-shrink-0"
          style={{ background: gradient }}
        >
          {icon}
        </div>
      </div>
      <div className="border-t border-gray-100 dark:border-white/5 pt-3">
        <p className="text-xs text-gray-400 dark:text-gray-500">Aggiornato adesso</p>
      </div>
    </div>
  );
}

function useDashboardStats() {
  const api = usePppApi();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.getDashboardStats({
      onSuccess: (data) => { setStats(data); setLoading(false); },
      onError:   ()     => { setLoading(false); },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { stats, loading };
}

export function ProcedimentiAttiviWidget({ _locate }) {
  const { stats, loading } = useDashboardStats();
  const navigate = useNavigate();

  return (
    <PppStatCard
      icon={<MdOutlineAccountBalance />}
      label={_locate('ppp_widget_procedimenti_attivi')}
      value={stats?.procedimentiAttivi}
      sub={stats ? _locate('ppp_widget_procedimenti_totali_sub').replace('{n}', stats.procedimentiTotali) : null}
      gradient="linear-gradient(135deg, #186766 0%, #1a9e9c 100%)"
      loading={loading}
      onClick={() => navigate('/ppp')}
    />
  );
}

export function ScadenzeCriticheWidget({ _locate }) {
  const { stats, loading } = useDashboardStats();
  const navigate = useNavigate();

  return (
    <PppStatCard
      icon={<MdSchedule />}
      label={_locate('ppp_widget_scadenze_imminenti')}
      value={stats?.scadenzeImminenti}
      sub={stats?.scadenzeOggi > 0
        ? _locate('ppp_widget_scadenze_oggi_sub').replace('{n}', stats.scadenzeOggi)
        : _locate('ppp_widget_scadenze_sette_giorni')}
      gradient="linear-gradient(135deg, #d97706 0%, #f59e0b 100%)"
      loading={loading}
      onClick={() => navigate('/ppp/report-ritardi')}
    />
  );
}

export function RitardiWidget({ _locate }) {
  const { stats, loading } = useDashboardStats();
  const navigate = useNavigate();

  return (
    <PppStatCard
      icon={<MdWarning />}
      label={_locate('ppp_widget_scadenze_in_ritardo')}
      value={stats?.scadenzeInRitardo}
      sub={stats?.scadenzeInRitardo > 0 ? _locate('ppp_widget_ritardi_art2') : _locate('ppp_widget_nessun_ritardo')}
      gradient={
        stats?.scadenzeInRitardo > 0
          ? 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)'
          : 'linear-gradient(135deg, #059669 0%, #10b981 100%)'
      }
      loading={loading}
      onClick={() => navigate('/ppp/report-ritardi')}
    />
  );
}
